module.exports = __webpack_public_path__ + "static/img/alert-circle.c6cc02b9.svg";